
<template>
  <v-container>
    <v-row  justify="space-around">
     <v-img max-width="400" src='https://storage.googleapis.com/donorconnection-df169.appspot.com/newlogo.png'/>
    </v-row>

  <v-row  class='pt-3 pb-3' justify="space-around">
    <h2 style='color :  #375d95'>DONATION PASSPORT</h2>
    </v-row>
    <v-row  justify="space-around" v-if='loading'>
    <v-skeleton-loader
     width="400"
          type="card-avatar, article, article "
        ></v-skeleton-loader>
    </v-row>
    <v-row v-else >
      <v-col lg='3' cols='12' sm='12'>
        <v-card  v-if='assetDetail.isDiscovered'>
            <v-card-title class=" green lighten-1">
        
        <h3 style='color:white' class="title font-weight text-center grow">
         DONATION HISTORY
        </h3>
      </v-card-title>
       <v-card-title class='title'>Date ID Created: <br />{{donationCreatedDate}}</v-card-title>
         <v-card-title class='title'>Date Received: <br />{{donationReceivedTime}}</v-card-title>
           <v-card-title class='title'>Received by: <br />{{refurbisherName}}</v-card-title>
             <v-card-title class='title'>Donation Lot: <br />{{assetDetail.donations}}</v-card-title>
               <v-card-title class='title'>Donor ID: <br />{{donorID}}</v-card-title>
                 <v-card-title class='title'>Nonprofit Benefited: <br />{{nonProfitName}}</v-card-title>
        </v-card>
      </v-col>
      <v-col v-if='assetDetail.isDiscovered' lg='5' cols='12' sm='12'>
         <v-card  >
         <v-card-title class="green lighten-1">
        
        <h3 style='color:white' class="title font-weight text-center grow">
          ID: {{this.$route.params.id}}
        </h3>
        
      </v-card-title>
      <v-card-title class='title'>Status: {{assetDetail.status}}</v-card-title>
             <v-card-title class='title'>Asset Type: {{assetDetail.assetType}}</v-card-title>
            <v-card-title class='title'>Notes: {{assetDetail.notes}}</v-card-title>
        
        <div v-if='assetDetail.assetType === "computer"'>
        <v-card-title class='title'>{{assetDetail.Discovery.SystemInfo.Make}} {{assetDetail.Discovery.SystemInfo.Model}} {{assetDetail.Discovery.CpuTitle}}, {{assetDetail.Discovery.RamTitle}} GB RAM, {{assetDetail.Discovery.HddTitle}} GB HDD</v-card-title>
      
     

 <v-list two-line>
 <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/organization-filled.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Make</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.SystemInfo.Make}}</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/material/48/000000/laptop.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
             <v-list-item-title>Model</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.SystemInfo.Model}}</v-list-item-title>
           
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/bag-brand.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
             <v-list-item-title>Serial</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.SystemInfo.Serial}}</v-list-item-title>
           
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/metro/52/000000/processor.png">
            </v-avatar>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Processor</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.CpuTitle}}</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/wired/64/000000/memory-slot.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Memory</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.RamTitle}} GB</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/hdd-filled.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>Storage</v-list-item-title>
            <v-list-item-title>{{assetDetail.Discovery.HddTitle}} GB</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/100/000000/video-card-filled.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>Video Card</v-list-item-title>
            <v-list-item-title v-if='assetDetail.Discovery.GraphCardsInfo'>{{assetDetail.Discovery.GraphCardsInfo[0].GraphicCardName}}</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
       
      
      </v-list>
        
    
      
<v-subheader><b>Misc hardware spec</b></v-subheader>
          <v-container fluid>
        <v-layout
          row
          wrap
        >
          <v-flex
            v-for='(item,index) in checkBoxesList'
            xs6
            sm4
            md4
            :key='index'
          >
            <v-checkbox
              :disabled='true'
              :label='item.name'
              v-model='assetDetail.mischardwarespec[item.value]'
              hide-details
            ></v-checkbox>

          </v-flex>
        </v-layout>
      </v-container>

</div>

<div v-else>

<v-card-title class='title'>{{assetDetail.PhoneTabletDiscovery.Make}} {{assetDetail.PhoneTabletDiscovery.Model}}, {{assetDetail.PhoneTabletDiscovery.Storage}}, {{assetDetail.PhoneTabletDiscovery.Carrier}} </v-card-title>



 <v-list two-line>
 <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/organization-filled.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Make</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Make}}</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/material/48/000000/laptop.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
             <v-list-item-title>Model</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Model}}</v-list-item-title>
           
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/bag-brand.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
             <v-list-item-title>Serial</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Serial}}</v-list-item-title>
           
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
         <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
              <img src="https://img.icons8.com/ios/50/000000/hdd-filled.png">
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
             <v-list-item-title>Storage</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Storage}}</v-list-item-title>
           
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
            <img src="https://img.icons8.com/wired/64/000000/radio-tower.png"/>
            </v-avatar>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Carrier</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Carrier}}</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
            <img src="https://img.icons8.com/ios/64/000000/lock-portrait.png"/>
            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Carrier Lock</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.CarrierLock}}</v-list-item-title>
            
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
             <img src="https://img.icons8.com/ios/64/000000/lock-portrait.png"/>

            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>Activation Lock</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.ActivationLock}} </v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
<img src="https://img.icons8.com/wired/64/000000/barcode-scanner-2.png"/>            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>IMEI</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Imei}}</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
    <img src="https://img.icons8.com/wired/64/000000/lock-portrait.png"/>            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>Remote Device Management Lock</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.RemoteDeviceManagementLock}}</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
       
        <v-list-item>
          <v-list-item-action>
            <v-avatar tile
              :item="true"
              :size="30"
            >
<img src="https://img.icons8.com/wired/64/000000/invert-colors.png"/>            </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title>Color</v-list-item-title>
            <v-list-item-title>{{assetDetail.PhoneTabletDiscovery.Color}}</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
       
      
      </v-list>
</div>
      </v-card>
     
      </v-col>

    <v-col v-else md='12' cols='12' sm='12'>
     <v-card flat>
          <p class='subtitle text-center'>We will have the hardware spec for this machine soon</p>
         <p class='subtitle-2 text-center'>
            <img max-width='400px' src='https://storage.googleapis.com/donorconnection-df169.appspot.com/not%20yet.png' />
         </p>
      </v-card>
    </v-col>

    
         <v-col lg='4' cols='12' sm='12'>
        <v-card  v-if='assetDetail.isDiscovered'>
            <v-card-title  class="white--text green lighten-1">
         <h3 style='font-size : 1.20rem' class="text-center grow">CERTIFICATE OF DATA DESTRUCTION</h3>
      </v-card-title>
       <v-subheader class='orange--text' v-if='!wipeReport'>HDD Wipe Report not ready yet, please check again later.</v-subheader>
         <div class='ma-2'>
      <v-btn  block class=' primary'  :disabled='!wipeReport' @click='downloadReport(wipeReport)' >DOWNLOAD CERTIFICATE</v-btn>
       <v-card-title class='title'>BLOCKCHAIN TIMESTAMPS</v-card-title>
      <v-btn block  :disabled='!wipeReport' href='https://originstamp.com/verify/' >Verify Report</v-btn>
       <v-card-title class='subtitle-1'>Download the certificate and then follow the link above to verify the document's authenticity.</v-card-title>
      <v-btn block class='mt-5' :disabled='!bitcoin' title='Download Bitcoin Certificate' @click='getCert(0)' > <v-icon dark>
        mdi-bitcoin
      </v-icon>Bitcoin Certificate</v-btn>
      <v-btn block class='mt-5'  :disabled='!ethereum' title='Download Ethereum Certificate' @click='getCert(1)' > <v-icon dark>
        mdi-ethereum
      </v-icon>Ethereum Certificate</v-btn>
      <v-btn block class='mt-5'  :disabled='!aion' title='Download Aion Certificate' @click='getCert(2)' > <v-icon dark>
        mdi-link
      </v-icon>Aion Certificate</v-btn>
      <br/>
      </div>
        </v-card>
      </v-col>

    </v-row>

   
  </v-container>
</template>


<script>
  export default {
    watch: {
    '$route.params.id': function (id) {
       this.getAsset(id);
    }
  },
  
  mounted(){
    this.getAsset(this.$route.params.id);
  },
  methods:{
    async getCert(type){
          const res = await this.$axios.post("https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/getProof", {
      coinType: type,
      hash: this.hashString,
    }
    );
    this.downloadReport(res.data.data.download_url)
    },
    downloadReport(downloadURL){
     var link = document.createElement("a");
      link.download = "something";
      link.target = "blank"
      link.href = downloadURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    generateColor(step){
      if(step > this.donationData.step){
        return "blue"
      }else{
        return "green"
      }
    },
    generateIcon(step){
     if(this.donationData.step === step){
       return "star";
     }else if ( this.donationData.step > step){
       return "check"
     }else {
       return "hourglass_empty"
     }
    },
    async getAsset(id){
        await this.$axios.get(
          'https://us-central1-donorconnection-df169.cloudfunctions.net/partnerapi/assets/'+id).then((response) => {
              this.assetDetail = response.data.asset;
              this.donationCreatedDate = response.data.donationCreatedDate;
              this.donationReceivedTime = response.data.donationReceivedTime;
              this.nonProfitName = response.data.nonProfitName;
              this.refurbisherName = response.data.receviedBy;
              this.donorID = response.data.donorID;
              this.wipeReport = response.data.hddWipeData;
              this.certificateReport = response.data.hash;
              this.loading = false;
              this.hashString = response.data.hashString
        }).catch((error) => {
          console.log(error)
        })
        if (this.certificateReport.length > 0){
          if (this.certificateReport[0].transaction) {
            this.bitcoin = true;
          }
           if (this.certificateReport[1].transaction) {
            this.ethereum = true;
          }
           if (this.certificateReport[2].transaction) {
            this.aion = true;
          }
        }
      },
  },
    data: () => ({
      hashString : false,
      bitcoin : false,
      ethereum : false,
      aion : false,
      certificateReport : [],
      wipeReport : null,
      donationCreatedDate : null,
      donationReceivedTime : null,
      donorID : null,
      nonProfitName : null,
      refurbisherName : null,
      checkBoxesList: [
        { name: "DisplayPort", value: "displayPort" },
        { name: "Gigabit Ethernet", value: "ethernet" },
        { name: "Mini DisplayPort", value: "minidisplayport" },
        { name: "HDMI", value: "hdmi" },
        { name: "Micro-HDMI", value: "microHDMI" },
        { name: "Micro-USB", value: "microUSB" },
        { name: "Mini Gigabit Ethernet", value: "miniEthernet" },
        { name: "Mini-USB", value: "miniUSB" },
        { name: "USB 1.0/1.1", value: "usb1" },
        { name: "USB 2.0", value: "usb2" },
        { name: "10/100 LAN Card", value: "lanCard" },
        { name: "3D Camera", value: "camera3d" },
        { name: "Backlit Keyboard", value: "backLitKeyboard" },
        { name: "Bluetooth", value: "bluetooth" },
        { name: "Built-in Microphone", value: "microphone" },
        { name: "Built-in Webcam", value: "webcam" },
        { name: "HSDPA", value: "hsdpa" },
        { name: "Rugged", value: "rugged" },
        { name: "Tablet PC", value: "tabletPC" },
        { name: "Touchscreen", value: "touchScreen" }
      ],
        assetDetail : null,
      loading : true,
      donationData : null,
    }),
  }
</script>